function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState, useContext } from "react";
const LoadingContext = /*#__PURE__*/ createContext();
export const LoadingProvider = ({ children })=>{
    const [isLoadingScreen, setLoadingScreen] = useState(false);
    const [loadingScreenType, setLoadingScreenType] = useState(null);
    return /*#__PURE__*/ _jsx(LoadingContext.Provider, {
        value: {
            isLoadingScreen,
            setLoadingScreen,
            loadingScreenType,
            setLoadingScreenType
        },
        children: children
    });
};
export const useLoadingScreenContext = ()=>useContext(LoadingContext);
export const withLoadingContext = (WrappedComponent)=>{
    return function Wrapper(props) {
        return /*#__PURE__*/ _jsx(LoadingContext.Consumer, {
            children: (context)=>/*#__PURE__*/ _jsx(WrappedComponent, _object_spread({}, props, context))
        });
    };
};
